<mat-form-field appearance="fill" class="w-100 form-field mat-form-whitebox" >
    <mat-label>
      <!-- <mat-icon [class]="title.iconClass">{{title.icon}}</mat-icon> -->
      {{title.text}}
    </mat-label>
    <mat-select [placeholder]="title.text" multiple="true" [(ngModel)]="selectedItems" (selectionChange)="onSelectionChange()">
        <div class="mx-1">
            <input type="text" name="search" class="w-100 d-flex m-auto p-2" placeholder="search" [(ngModel)]="search" autofocus>
        </div>
      <mat-option *ngFor="let x of getOptions()" [value]="x.value">
        {{x.viewValue}}
      </mat-option>
    </mat-select>
</mat-form-field>